import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import useSeo from "@/lib/useSeo";
import ModuleRenderer from "@/components/public/ModuleRenderer";

export default function CmsPage() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    api.get(`/public/pages/${slug}`).then((r) => setPage(r.data)).catch(() => nav("/404", { replace: true })).finally(() => setLoading(false));
  }, [slug, nav]);
  useSeo(page ? { title: page.seo?.title || page.title, description: page.seo?.description } : {});
  if (loading) return <div className="pt-40 pb-40 text-center text-emerald-800">Loading…</div>;
  if (!page) return null;
  return (
    <div className="pt-28" data-testid="cms-page">
      <ModuleRenderer modules={page.modules} />
    </div>
  );
}
